export const API_URLS = {
    brandCardsListing: '/umbraco/api/brandapi/cards',
    contentCardsListing: '/umbraco/api/contentapi/cards',
    searchSubmit: '/api/search/submit',
    searchTypeahead: '/api/search/typeahead',
    savePage: '/umbraco/api/favouritesapi/postfavouriteupdate',
    // SIGN IN
    signIn: '/auth/login',
    forgottenPassword: '/auth/forgotpassword',
    resetPassword: '/auth/resetpassword',
    signUp: '/umbraco/api/crmapi/createaccount',
    checkCompanyName: '/umbraco/api/crmapi/checkcompanyname',
    // PORTAL FORMS
    communities: '/umbraco/api/portalapi/communities',
    myAccount: '/umbraco/api/portalapi/myaccount',
    newsletters: '/umbraco/api/portalapi/newsletters',
};
